import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 22 22"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19 0H3C1.3 0 0 1.27 0 2.932v3.91c0 1.663 1.3 2.934 3 2.934h16c1.7 0 3-1.271 3-2.933v-3.91C22 1.271 20.7 0 19 0m1 6.843c0 .586-.4.977-1 .977H3c-.6 0-1-.39-1-.977v-3.91c0-.587.4-.978 1-.978h16c.6 0 1 .39 1 .977v3.911m-1 4.888H3c-1.7 0-3 1.27-3 2.932v3.91c0 1.663 1.3 2.934 3 2.934h16c1.7 0 3-1.271 3-2.933v-3.91c0-1.662-1.3-2.933-3-2.933m1 6.843c0 .586-.4.977-1 .977H3c-.6 0-1-.39-1-.977v-3.91c0-.587.4-.978 1-.978h16c.6 0 1 .39 1 .977zM4.3 4.203c-.2.195-.3.39-.3.684 0 .293.1.488.3.684.2.195.4.293.7.293s.5-.098.7-.293c.2-.196.3-.391.3-.684s-.1-.49-.3-.685a.98.98 0 0 0-1.4.001m0 11.73c-.2.196-.3.391-.3.685 0 .293.1.488.3.684.2.195.4.293.7.293s.5-.098.7-.293c.2-.196.3-.391.3-.684s-.1-.49-.3-.685a.98.98 0 0 0-1.4 0"
    }, null, -1)
  ]))]))
}
export default { render: render }